var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReporting01 = function SvgReporting01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "reporting-01_svg2__a",
    x1: 27.44,
    x2: 166.35,
    y1: 168.99,
    y2: 30.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3fe5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f434e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#dd1de7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#cd0ce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c403e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c100e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#reporting-01_svg2__a",
    id: "reporting-01_svg2__b",
    x1: 29.22,
    x2: 168.14,
    y1: 170.78,
    y2: 31.86
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#reporting-01_svg2__a",
    id: "reporting-01_svg2__c",
    x1: 72.05,
    x2: 210.97,
    y1: 213.6,
    y2: 74.68
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M91.67 102.74V12.5c0-2.3-1.87-4.17-4.17-4.17-48.25 0-87.5 43-87.5 95.84S42.99 200 95.83 200c23.64 0 36.43-4.28 52.65-17.62a4.167 4.167 0 0 0 .64-5.77l-57.46-73.87Zm4.16 88.93c-48.25 0-87.5-39.25-87.5-87.5s33.28-84.98 75-87.39v87.38c0 .92.31 1.82.88 2.56l55.8 71.74c-13.16 10.05-24.13 13.2-44.18 13.2Z",
    style: {
      fill: "url(#reporting-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.17 100h91.67c2.3 0 4.17-1.87 4.17-4.17C200 42.99 157.01 0 104.17 0c-2.3 0-4.17 1.87-4.17 4.17v91.67c0 2.3 1.87 4.17 4.17 4.17Zm4.16-91.57c44.94 2.12 81.12 38.29 83.23 83.23h-83.23z",
    style: {
      fill: "url(#reporting-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.83 108.33H112.5c-1.6 0-3.08.93-3.77 2.38s-.48 3.17.52 4.41l54.17 67.06c.72.91 1.79 1.46 2.95 1.54h.29c1.05 0 2.07-.4 2.84-1.12 19.37-18.07 30.49-43.62 30.49-70.11 0-2.3-1.87-4.17-4.17-4.17Z",
    style: {
      fill: "url(#reporting-01_svg2__c)"
    }
  }));
};
export default SvgReporting01;